import CloseRoundedIcon from "@mui/icons-material/CloseRounded"
import {
    Dialog,
    DialogActions,
    DialogTitle,
    IconButton,
    Typography,
} from "@mui/material"
import { FC } from "react"

import { GRID_SPACING } from "../../../themes/defaultThemeParams"

interface DialogProps {
    open: boolean
    onClose: () => void
    fullScreen: boolean
    title: string
    message: string
}

const SimpleDialog: FC<DialogProps> = ({
    open,
    onClose,
    fullScreen,
    title,
    message,
}) => (
    <Dialog open={open} onClose={onClose} fullScreen={fullScreen}>
        <DialogTitle sx={{ padding: GRID_SPACING }}>{title}</DialogTitle>
        <Typography variant="body1" sx={{ padding: GRID_SPACING }}>
            {message}
        </Typography>
        {fullScreen && (
            <DialogActions
                sx={{
                    justifyContent: "flex-end",
                    flexGrow: 1,
                    alignItems: "flex-end",
                }}
            >
                <IconButton
                    edge="end"
                    color="inherit"
                    onClick={onClose}
                    aria-label="close"
                >
                    <CloseRoundedIcon />
                </IconButton>
            </DialogActions>
        )}
    </Dialog>
)

export default SimpleDialog
